import React, { useState, useRef, useEffect } from "react";
import { getHeroIcon } from "../../_helpers/heroicons";
import styles from "../styles/QurealRichEditor.module.css";

const ListDropdown = ({ editor }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Handle click outside to close dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Get current list type or "List" if no list is active
    const getCurrentListText = () => {
        if (editor.isActive("bulletList")) return "Bullet List";
        if (editor.isActive("orderedList")) return "Numbered List";
        return "List";
    };

    // Get appropriate icon for current state
    const getCurrentIcon = () => {
        if (editor.isActive("bulletList"))
            return getHeroIcon("list-bullet", { width: "18px" });
        if (editor.isActive("orderedList"))
            return getHeroIcon("numbered-bullet", { width: "18px" });
        return getHeroIcon("list-bullet", { width: "18px" });
    };

    return (
        <div className={styles.dropdown} ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`${styles.button} ${styles.dropdownToggle} ${
                    editor.isActive("bulletList") ||
                    editor.isActive("orderedList")
                        ? styles.isActive
                        : ""
                }`}
                title="List options"
            >
                <span className={styles.dropdownLabel}>{getCurrentIcon()}</span>
                {getHeroIcon("chevron-down", { width: "12px" })}
            </button>

            {isOpen && (
                <div className={styles.dropdownMenu}>
                    <button
                        onClick={() => {
                            editor.chain().focus().toggleBulletList().run();
                            setIsOpen(false);
                        }}
                        className={`${styles.dropdownItem} ${
                            editor.isActive("bulletList")
                                ? styles.dropdownItemActive
                                : ""
                        }`}
                    >
                        {getHeroIcon("list-bullet", { width: "18px" })}
                        <span>Bullet List</span>
                    </button>
                    <button
                        onClick={() => {
                            editor.chain().focus().toggleOrderedList().run();
                            setIsOpen(false);
                        }}
                        className={`${styles.dropdownItem} ${
                            editor.isActive("orderedList")
                                ? styles.dropdownItemActive
                                : ""
                        }`}
                    >
                        {getHeroIcon("numbered-bullet", { width: "18px" })}
                        <span>Order List</span>
                    </button>
                    <button
                        onClick={() => {
                            // First try to lift the list item if we're in a list
                            if (
                                editor.isActive("bulletList") ||
                                editor.isActive("orderedList")
                            ) {
                                editor
                                    .chain()
                                    .focus()
                                    .liftListItem("listItem")
                                    .run();
                            }
                            setIsOpen(false);
                        }}
                        className={`${styles.dropdownItem}`}
                    >
                        {getHeroIcon("document-text", { width: "18px" })}
                        <span>Remove </span>
                    </button>
                </div>
            )}
        </div>
    );
};

export default ListDropdown;
